import { localStorage, setTwProfilekey } from "@jog/shared"
import { useSession } from "next-auth/react"
import { useEffect } from "react"
import { v4 } from "uuid"

export const useTwProfileKey = () => {
    const session = useSession()
    useEffect(() => {
        if (session.status === "loading") return
        const key = localStorage.getItem<{ key: string }>("TwRandomKey", { key: "" })?.key || v4()
        localStorage.setItem<{ key: string }>("TwRandomKey", { key })
        setTwProfilekey(session.data?.user?.id || key)
    }, [session])
}
